import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SmallBusinessOption } from '../classes/models/small-business-option';

@Injectable({
  providedIn: 'root'
})
export class SmallBusinessOptionService {
  constructor(private http: HttpClient) {}

  // Currently, only Vendors can save small business options.
  saveSmallBusinessOptions(
    VendorId: number,
    SmallBusinessOptions: SmallBusinessOption[],
    query = {}
  ): Observable<any> {
    return this.http.post(
      `/api/v2/vendor/${VendorId}/smallBusinessOption`,
      SmallBusinessOptions,
      { params: query }
    );
  }
}
